import { TypeMenuItem } from "./type-menu-item";

export class MenuItem {
    
    constructor(
        public id: string,
        public label: string,
        public type: TypeMenuItem = TypeMenuItem.INTERNAL_APP,
        public link: string = "",
        public nbNotif: number = 0,
        public labelNotif: string = ""
    ){
    }
}
